import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import PublicInfoSectionWrapper from "../../components/users/PublicInfoSectionWrapper";
import MyCourseSection from "../../components/users/MyCourseSection";
import MyPictureSection from "../../components/users/MyPictureSection";
import MyAvailabilitySection from "../../components/users/MyAvailabilitySection";
import UserProfileDetails from "../../components/users/UserProfileDetails";

import {
  addAvailableTime,
  deleteAvailableTime,
  deleteImage,
  deactivateLeaderProfile,
  activateLeaderProfile,
  getAllLeader,
  getUserData,
  partialProfileUpdate,
  updateLeaderProfile,
  uploadImage,
} from "../../store/actions/user.action";
import { getAllMeetingLinks } from "../../store/actions/meeting.action";
import {
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
} from "@material-tailwind/react";

import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { MenuBar } from "../../components/Menu/Menu";
import { AddLeaderProfile } from "../../components/Dialog/AddLeaderProfile";
import DeleteAccountModal from "../../components/Dialog/DeleteAccountModal";
import upArrow from "../../assets/image/upArrow.svg";
import ChangeImage from "../../assets/image/change.svg";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
// import TimeTable from "../../components/Table/TimeTable";
import {
  transform_skillLevel,
  transform_timezone,
  transform_languages,
  // transform_timeslot
} from "../../components/Transformation/Transformations";
import { useTranslation } from "react-i18next";
import QRCodeGenerator from "../../utils/qrcode";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import VisaIcon from "../../assets/image/Visa.svg";
import Mastercard from "../../assets/image/Mastercard.svg";
import AmericanEx from "../../assets/image/AmericanEx.svg";
import Alipay from "../../assets/image/Alipay.svg";
import WeChat from "../../assets/image/wechat-payment.svg";
import CashApp from "../../assets/image/Cashapp.svg";
import { languages } from "../../components/Transformation/Transformations";

export default function UserProfile({ inputTab }) {
  const { t } = useTranslation();
  const invitationBaseUrl =
    typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";

  // const [birthday, setBirthday] = useState("");
  const [birthYear, setBirthYear] = useState(
    new Date().getFullYear().toString()
  );
  const handleYearChange = (e) => {
    const inputYear = e.target.value;
    // Only accept a 4-digit number as valid input
    if (inputYear.length <= 4 && !isNaN(inputYear)) {
      setBirthYear(inputYear);
    } else {
      setBirthYear(new Date().getFullYear().toString());
    }
  };
  // Generate an array of years for the dropdown
  const years = [];
  let currentYear = new Date().getFullYear();
  let minYear = 1950;
  for (let year = currentYear; year >= minYear; year--) {
    years.push(year);
  }

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [myCredit, setMyCredit] = useState("");
  // const [preferredName, setPreferredName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [addLeader, setAddLeader] = useState(false);
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
  //   const [addLearner, setAddLearner] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [firstLanguage, setFirstLanguage] = useState("");
  const [firstLanguageSkillLevel, setFirstLanguageSkillLevel] = useState("");
  const [alsoSpeak, setAlsoSpeak] = useState("");
  const [school, setSchool] = useState("");
  const [cityCountry, setCityCountry] = useState("");
  const [targetGraduationYearHighSchool, setTargetGraduationYearHighSchool] = useState("");
  const [totalTeachingMinutes, setTotalTeachingMinutes] = useState("");
  const [totalLearningMinutes, setTotalLearningMinutes] = useState("");
  const [
    availableTeachingMinutesForCertificate,
    setAvailableTeachingMinutesForCertificate,
  ] = useState("");
  const [availableMoneyToCashOut, setAvailableMoneyToCashOut] = useState("");
  const [meetingProvider, setMeetingProvider] = useState("");

  const [tempImage, setTempImage] = useState(null);
  const [tempFile, setTempFile] = useState(null);
  // const [weekDay, setWeekDay] = useState("");
  // const [selectWeekDay, setSelectWeekDay] = useState("");
  const [timeZone, setTimeZone] = useState("");
  // const [time, setTime] = useState("");
  // const [hour, setHour] = useState(null);
  // const [minute, setMinute] = useState(null);
  const [isAvailableTimeChange, setIsAvailableTimeChange] = useState(false);
  const [currentDay, setCurrentDay] = useState(0); // eslint-disable-line no-unused-vars
  // const [selectTime, setSelectTime] = useState("");
  // const [availabilityData, setAvailabilityData] = useState({});
  // const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  // const [selectedDayTime, setSelectedDayTime] = useState({ day: "", time: "" });
  const [currentTab, setCurrentTab] = useState(inputTab);
  const [loading, setLoading] = useState(true);
  const [savingImage, setSavingImage] = useState(false);
  const [invitationCode, setInvitationCode] = useState("");
  const [invitationUrl, setInvitationUrl] = useState("");
  // const [selectedTime, setSelectedTime] = useState("");
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [allBookedSlots, setAllBookedSlots] = useState({});
  const [initialBookedSlots, setInitialBookedSlots] = useState([]);

  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  const token = localStorage.getItem("token");
  const navigation = useNavigate();
  useEffect(() => {
    if (!token) {
      navigation(`/login`);
    }
  }, [token, navigation]);

  const mail = localStorage.getItem("mail");
  const userProfile = useSelector((state) => state.user.currentUser);
  const meetingLinks = useSelector((state) => state.meeting.meetingLinks);
  // const user_timezone = userProfile?.timezone;
  const leaderData = useSelector((state) => state.user.getLeaders);
  const parsedUserProfile = useMemo(() => {
    let parsedProfile;
    try {
      if (
        userProfile &&
        typeof userProfile === "string" &&
        userProfile.trim() !== ""
      ) {
        parsedProfile = JSON.parse(userProfile);
      } else {
        parsedProfile = userProfile;
      }
    } catch (error) {
      console.error("Error parsing userProfile JSON:", error);
      parsedProfile = {};
    }
    
    // Add meeting link data from Redux store
    if (meetingLinks && Array.isArray(meetingLinks) && meetingLinks.length > 0) {
      // Filter meeting links to get only the current user's links
      const userLinks = meetingLinks.filter(link => 
        link.user === parsedProfile?.email || 
        link.user_email === parsedProfile?.email ||
        link.owner === parsedProfile?.email
      );
      
      const userMeetingLink = userLinks.length > 0 ? userLinks[0] : meetingLinks[0];
      
      if (userMeetingLink) {
        parsedProfile = {
          ...parsedProfile,
          meeting_link: userMeetingLink?.meeting_link,
          meeting_link_id: userMeetingLink?.id,
          meeting_link_provider: userMeetingLink?.meeting_link_provider,
          meeting_link_password: userMeetingLink?.meeting_link_password,
        };
      }
    }
    
    return parsedProfile;
  }, [userProfile, meetingLinks]);

  useEffect(() => {
    if (token && mail) dispatch(getUserData({ token, mail }));
    dispatch(getAllLeader(token));
    if (token) dispatch(getAllMeetingLinks({ token }));
  }, [dispatch, token, mail]);

  const closeIsChange = () => {
    setIsChange(false);
    setTempImage(null);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    setTempFile(file);
    if (file) {
      setTempImage(URL.createObjectURL(file));
    }
    event.target.value = null;
  };

  // const rowDelete = (index) => {
  //   const id = parsedUserProfile?.availabilities[index]?.id;
  //   dispatch(deleteAvailableTime({ id, token, mail }));
  // };

  const deactivateLeader = (index) => {
    dispatch(
      deactivateLeaderProfile({
        token,
        mail,
        index: index,
      })
    );
  };

  const activateLeader = (index) => {
    dispatch(
      activateLeaderProfile({
        token,
        mail,
        index: index,
      })
    );
  };

  const updateLeader = (
    teaching_language,
    teaching_language_skill_level,
    introduction,
    interested_topics,
    creditAdjustmentRate,
    index
  ) => {
    console.log(interested_topics.length);
    if (interested_topics.length > 198) {
      toast.warn(t("leader_profile.interested_topics_too_long"), {
        position: "bottom-right",
      });
      return;
    }

    dispatch(
      updateLeaderProfile({
        token,
        mail,
        teaching_language,
        teaching_language_skill_level,
        introduction,
        interested_topics,
        creditAdjustmentRate,
        index: leaderData?.results[index]?.id,
      })
    );
  };

  useEffect(() => {
    if (isAvailableTimeChange === false) {
      setSelectedSlots([]);
    }
    if (isAvailableTimeChange) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => document.body.classList.remove("overflow-hidden");
  }, [isAvailableTimeChange]);

  useEffect(() => {
    if (parsedUserProfile) {
      const userData = parsedUserProfile;
      setFirstName(userData?.first_name || "");
      setLastName(userData?.last_name || "");
      setMyCredit(userData?.credits || "0");
      setTotalTeachingMinutes(userData?.total_teaching_minutes || "0");
      setTotalLearningMinutes(userData?.total_learning_minutes || "0");
      setAvailableTeachingMinutesForCertificate(
        userData?.available_teaching_minutes_for_certificate || "0"
      );
      setAvailableMoneyToCashOut(
        userData?.available_money_to_cash_out / 100 || "0"
      );
      setMeetingProvider(userData?.meeting_provider || "");

      setBirthYear(userData?.year_of_birth || "");
      setSchool(userData?.school || "");
      setCityCountry(userData?.city_country || "");
      setTargetGraduationYearHighSchool(userData?.target_graduation_year_high_school || "");
      setTimeZone(userData?.timezone || "");
      setFirstLanguage(userData?.first_language || "");
      setFirstLanguageSkillLevel(userData?.first_language_skill_level || "");
      setAlsoSpeak(userData?.also_speak || "");
    }
  }, [parsedUserProfile]);

  const sendUserBasicData = () => {
    const profileData = {
      firstName: firstName,
      lastName: lastName,
      timezone: timeZone,
      meetingProvider: meetingProvider,
      mail,
    };
    const id = parsedUserProfile?.id;
    dispatch(partialProfileUpdate(profileData, id, token));
    setIsChange(false);
  };

  const sendData = () => {
    const prevBirthYear = parsedUserProfile?.year_of_birth;
    const prevSchool = parsedUserProfile?.school;
    const prevCityCountry = parsedUserProfile?.city_country;
    const prevTargetGraduationYearHighSchool = parsedUserProfile?.target_graduation_year_high_school;
    const prevFirstLanguage = parsedUserProfile?.first_language;
    const prevFirstLanguageSkillLevel = parsedUserProfile?.first_language_skill_level;
    const prevAlsoSpeak = parsedUserProfile?.also_speak;

    var profileData = {};
    if (birthYear) {
      profileData = {
        birthYear: birthYear || prevBirthYear,
        school: school || prevSchool,
        cityCountry: cityCountry || prevCityCountry,
        targetGraduationYearHighSchool: targetGraduationYearHighSchool || prevTargetGraduationYearHighSchool,
        firstLanguage: firstLanguage || prevFirstLanguage,
        firstLanguageSkillLevel: firstLanguageSkillLevel || prevFirstLanguageSkillLevel,
        alsoSpeak: alsoSpeak || prevAlsoSpeak,
        mail,
      };
    } else {
      profileData = {
        school: school || prevSchool,
        cityCountry: cityCountry || prevCityCountry,
        targetGraduationYearHighSchool: targetGraduationYearHighSchool || prevTargetGraduationYearHighSchool,
        firstLanguage: firstLanguage || prevFirstLanguage,
        firstLanguageSkillLevel: firstLanguageSkillLevel || prevFirstLanguageSkillLevel,
        alsoSpeak: alsoSpeak || prevAlsoSpeak,
        mail,
      };
    }
    const id = parsedUserProfile?.id;
    dispatch(partialProfileUpdate(profileData, id, token));
    setIsChange(false);
  };

  useEffect(() => {
    const userTimezone = parsedUserProfile?.timezone || moment.tz.guess();
    const availabilities = parsedUserProfile?.availabilities || [];

    const initialSlots = availabilities.map((slot) => {
      const localTime = moment()
        .tz(slot.timezone)
        .day(slot.day)
        .hour(slot.hour)
        .minute(slot.minute)
        .second(0)
        .tz(userTimezone);
      if (localTime.isBefore(moment())) {
        localTime.add(7, "days");
      }
      return {
        id: slot.id,
        day: localTime.format("ddd"),
        time: localTime.format("HH:mm"),
      };
    });

    setInitialBookedSlots(initialSlots);

    const slotsByDay = dayArray.reduce((acc, day) => {
      acc[day] = initialSlots
        .filter((slot) => slot.day === day)
        .map((slot) => slot.time);
      return acc;
    }, {});

    setAllBookedSlots(slotsByDay);

    setCurrentDay(new Date().getDay() || 7);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parsedUserProfile?.availabilities, parsedUserProfile?.timezone]);

  const dayArray = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const toggleSlot = (day, time) => {
    const slot = { day, time };

    // Check if it's an already booked slot
    const isAlreadyBooked = initialBookedSlots.some(
      (s) => s.day === day && s.time === time
    );

    if (isAlreadyBooked) {
      const isMarkedForDeletion = selectedSlots.some(
        (s) => s.day === day && s.time === time
      );

      if (isMarkedForDeletion) {
        setSelectedSlots(
          selectedSlots.filter((s) => !(s.day === day && s.time === time))
        );
      } else {
        setSelectedSlots([...selectedSlots, slot]);
      }
    } else {
      const isSelected = selectedSlots.some(
        (s) => s.day === day && s.time === time
      );
      if (isSelected) {
        setSelectedSlots(
          selectedSlots.filter((s) => !(s.day === day && s.time === time))
        );
      } else {
        setSelectedSlots([...selectedSlots, slot]);
      }
    }
  };

  const saveTimeSlots = () => {
    const userTimezone = parsedUserProfile?.timezone || moment.tz.guess();

    const toAdd = selectedSlots.filter(
      (slot) =>
        !initialBookedSlots.some(
          (booked) => booked.day === slot.day && booked.time === slot.time
        )
    );

    const toDelete = initialBookedSlots.filter((booked) =>
      selectedSlots.some(
        (slot) => slot.day === booked.day && slot.time === booked.time
      )
    );

    if (toAdd.length === 0 && toDelete.length === 0) {
      toast.warn("No changes to save!", { position: "bottom-right" });
      return;
    }

    toAdd.forEach(({ day, time }) => {
      const [hour, minute] = time.split(":");
      dispatch(
        addAvailableTime({
          day,
          hour: parseInt(hour),
          minute: parseInt(minute),
          token,
          timezone: userTimezone,
          mail,
        })
      );
    });

    toDelete.forEach(({ id }) => {
      dispatch(deleteAvailableTime({ id, token, mail }));
    });

    setSelectedSlots([]);
    setIsAvailableTimeChange(false);
  };

  const MAX_IMAGE_SIZE_KB = 500;
  const saveImage = async () => {
    if (!tempFile) {
      toast.warn("There is no image.", {
        position: "bottom-right",
      });
      return;
    }

    const imageSizeInMB = tempFile.size / 1024;

    if (imageSizeInMB > MAX_IMAGE_SIZE_KB) {
      alert(
        `Image size is too large. Please select an image smaller than ${MAX_IMAGE_SIZE_KB} KB.`
      );
      return;
    }
    setSavingImage(true);
    try {
      await dispatch(
        uploadImage({
          token,
          mail,
          image: tempFile,
          id: parsedUserProfile?.id,
        })
      );
      await new Promise((resolve) => setTimeout(resolve, 5000));
      setTempImage(null);
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setSavingImage(false);
    }
  };

  const deleteImg = () => {
    dispatch(
      deleteImage({
        token,
        mail,
        userId: parsedUserProfile?.id,
      })
    );
    setTempImage(null);
    setTempFile(null);
  };

  const data = [
    {
      label: t("user_home.profile"),
      value: "profile",
    },
    {
      label: t("user_home.leader_profile"),
      value: "leaderProfile",
    },
  ];

  const openIsChange = () => {
    setIsChange(true);
  };

  const closeMenuBar = () => {
    setMenuOpen(false);
  };

  const openMenuBar = () => {
    setMenuOpen(true);
  };

  const handleTabChange = (value) => {
    setCurrentTab(value);
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  useEffect(() => {
    setInvitationCode(parsedUserProfile?.invitation_code);
    setInvitationUrl(`${invitationBaseUrl}/?ref=${invitationCode}`);
  }, [leaderData, invitationCode, parsedUserProfile, invitationBaseUrl]);

  const [currentSection, setCurrentSection] = useState("section1");

  // Define sections with unique IDs and display names
  const sections = [
    { id: "section1", displayName: t("user_home.step_1") },
    { id: "section2", displayName: t("user_home.step_2") },
    { id: "section3", displayName: t("user_home.step_3") },
    { id: "section4", displayName: t("user_home.step_4") },
  ];

  return (
    <div className="max-w-screen-2xl mx-auto p-4 h-full">
      <Header openMenu={openMenuBar} />
      <Tabs value={currentTab}>
        <TabsHeader className="bg-[var(--brand)]">
          {data.map(({ label, value }) => (
            <Tab
              key={value}
              value={value}
              onClick={() => {
                handleTabChange(value);
              }}
            >
              <div className="flex items-center gap-2 md:text-xl sm:text-sm text-xs">
                {label}
              </div>
            </Tab>
          ))}
        </TabsHeader>
        <TabsBody className="min-h-[500px]">
          <TabPanel
            className="sm:p-4 py-4 px-0"
            key={"profile"}
            value={"profile"}
          >
            <div className="flex md:flex-row flex-col-reverse gap-5">
              <div className="md:w-2/4 w-full pt-10 relative">
                <button className="absolute top-0 right-0">
                  <img
                    src={ChangeImage}
                    alt="changeProfile"
                    className="md:w-[40px] md:h-[40px]"
                    onClick={openIsChange}
                  />
                </button>
                <UserProfileDetails
                  t={t}
                  isChange={isChange}
                  parsedUserProfile={parsedUserProfile}
                  firstName={firstName}
                  setFirstName={setFirstName}
                  lastName={lastName}
                  setLastName={setLastName}
                  mail={mail}
                  timeZone={timeZone}
                  setTimeZone={setTimeZone}
                  totalTeachingMinutes={totalTeachingMinutes}
                  totalLearningMinutes={totalLearningMinutes}
                  availableTeachingMinutesForCertificate={availableTeachingMinutesForCertificate}
                  availableMoneyToCashOut={availableMoneyToCashOut}
                  meetingProvider={meetingProvider}
                  setMeetingProvider={setMeetingProvider}
                  myCredit={myCredit}
                />
                <div className="flex  flex-col justify-center items-center  md:gap-4 gap-2 md:hidden block mt-4">
                  <a
                    href="/user/payment"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg sm:text-sm text-xs px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 "
                  >
                    {t("user_home.buy_credits")}
                  </a>
                  <a
                    href="/user/meetings"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg sm:text-sm text-xs px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 "
                  >
                    {t("user_home.all_courses")}
                  </a>
                  <a
                    href="/user/changePassword"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg sm:text-sm text-xs px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 "
                  >
                    {t("header.change_password")}
                  </a>
                </div>
              </div>
              <div className="w-2/4 md:m-0 ml-auto md:block hidden">
                <div className="flex flex-col bg-[#6C63FF33] items-center justify-center p-4 border-4 max-w-96 m-auto border-slate-500 rounded-xl">
                  <img src={upArrow} alt="upArrow" className="size-12 mb-2" />
                  <p className="text-center text-sm md:text-xl text-[#0d3624]">
                    {t("user_home.become_leader")}
                  </p>
                </div>
                <div className="flex flex-col justify-center items-center  md:gap-4 gap-2 mt-4">
                  <a
                    href="/user/payment"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    {t("user_home.buy_credits")}
                  </a>
                  <a
                    href="/user/meetings"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    {t("user_home.all_courses")}
                  </a>
                  <a
                    href="/user/changePassword"
                    className="text-white bg-[var(--brand)] hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-12 py-3 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    {t("header.change_password")}
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full flex flex-col gap-4 p-2 pb-12">
              <div className="flex justify-end">
                <div></div>
                <div className="basis-1/2 flex flex-col gap-4"></div>
              </div>

              <div className="flex flex-col xl:flex-row items-center gap-8">
                <div className="basis-1/2 flex flex-col items-center">
                  <div className="mt-[-35px]"></div>
                </div>
              </div>
              <div className="text-[20px] font-semibold text-center flex flex-wrap md:justify-center items-center gap-4 whitespace-nowrap overflow-x-auto">
                <div className="lg:text-xl md:text-lg text-sm">
                  {t("payment_page.text1")}
                </div>
                <div className="flex items-center md:gap-4 gap-2 flex-wrap">
                  <img src={VisaIcon} alt="Visa" className="h-12" />
                  <img src={Mastercard} alt="Mastercard" className="h-10" />
                  <img
                    src={AmericanEx}
                    alt="American Express"
                    className="h-10"
                  />
                  <img src={Alipay} alt="Alipay" className="h-8" />
                  <img src={CashApp} alt="CashApp" className="h-8" />
                  <div className="text-[#2dbd07] text-[8.7px] flex items-center">
                    <img src={WeChat} alt="WeChat" className="h-[35px] mr-1" />
                    微信支付
                  </div>
                </div>
              </div>
              {isChange && (
                <div className="flex justify-center gap-4">
                  <button
                    className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
                    onClick={closeIsChange}
                  >
                    {t("generic.cancel")}
                  </button>
                  <button
                    className="bg-[var(--brand)] rounded-[5px] w-[70px] h-[30px] xl:w-[100px] xl:h-[40px] text-white"
                    onClick={sendUserBasicData}
                  >
                    {t("generic.save")}
                  </button>
                </div>
              )}
            </div>

            <div className="flex justify-center"></div>

            <div>
              <p className="text-lg font-medium leading-relaxed text-gray-800 mt-4 font p-2 bg-[#6C63FF33] border-l-4 border-[var(--brand)] rounded-lg shadow-sm text-center">
                <li>{t("user_home.refer_other_1")}</li>
                <li>{t("user_home.refer_other_2")}</li>
                {t("user_home.refer_other_3")} {"\u00A0\u00A0\u00A0"}{" "}
                {invitationUrl}
              </p>
            </div>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <h1>QR Code for the URL: {invitationUrl}</h1>
              <QRCodeGenerator url={invitationUrl} width={300} />
            </div>

            {/* Danger Zone: Account Deletion */}
            <div className="mt-12 border border-red-200 bg-red-50/60 rounded-2xl p-6 sm:p-8 max-w-4xl mx-auto shadow-sm">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                <div>
                  <h3 className="text-lg font-bold text-red-700 flex items-center gap-2">
                    <span>⚠️</span>
                    {t("user_home.delete_account")}
                  </h3>
                  <p className="text-sm text-gray-600 mt-1 max-w-xl">
                    Once you delete your account, your profile is permanently deactivated, upcoming meetings are cancelled, and your courses will no longer be listed.
                  </p>
                </div>
                <button
                  type="button"
                  onClick={() => setDeleteAccountOpen(true)}
                  className="px-6 py-2.5 bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-medium text-sm rounded-xl transition-colors shadow-sm whitespace-nowrap self-start sm:self-auto"
                >
                  {t("user_home.delete_account")}
                </button>
              </div>
            </div>
          </TabPanel>
          <TabPanel key={"leaderProfile"} value={"leaderProfile"}>
            <Breadcrumbs
              sections={sections}
              currentSection={currentSection}
              setCurrentSection={setCurrentSection}
            />
            <div className="flex flex-col gap-10 mt-2">
              <PublicInfoSectionWrapper
                t={t}
                ChangeImage={ChangeImage}
                openIsChange={openIsChange}
                closeIsChange={closeIsChange}
                sendData={sendData}
                isChange={isChange}
                parsedUserProfile={parsedUserProfile}
                firstLanguage={firstLanguage}
                setFirstLanguage={setFirstLanguage}
                languages={languages}
                firstLanguageSkillLevel={firstLanguageSkillLevel}
                setFirstLanguageSkillLevel={setFirstLanguageSkillLevel}
                alsoSpeak={alsoSpeak}
                setAlsoSpeak={setAlsoSpeak}
                birthYear={birthYear}
                handleYearChange={handleYearChange}
                years={years}
                school={school}
                setSchool={setSchool}
                cityCountry={cityCountry}
                setCityCountry={setCityCountry}
                targetGraduationYearHighSchool={targetGraduationYearHighSchool}
                setTargetGraduationYearHighSchool={setTargetGraduationYearHighSchool}
                transform_languages={transform_languages}
                transform_skillLevel={transform_skillLevel}
              />

              <MyCourseSection
                t={t}
                ChangeImage={ChangeImage}
                setAddLeader={setAddLeader}
                leaderData={leaderData}
                parsedUserProfile={parsedUserProfile}
                updateLeader={updateLeader}
                deactivateLeader={deactivateLeader}
                activateLeader={activateLeader}
              />
            </div>

            <MyAvailabilitySection
              t={t}
              ChangeImage={ChangeImage}
              setIsAvailableTimeChange={setIsAvailableTimeChange}
              isAvailableTimeChange={isAvailableTimeChange}
              parsedUserProfile={parsedUserProfile}
              allBookedSlots={allBookedSlots}
              transform_timezone={transform_timezone}
              initialBookedSlots={initialBookedSlots}
              selectedSlots={selectedSlots}
              toggleSlot={toggleSlot}
              saveTimeSlots={saveTimeSlots}
            />

            <MyPictureSection
              t={t}
              parsedUserProfile={parsedUserProfile}
              loading={loading}
              savingImage={savingImage}
              tempImage={tempImage}
              fileInputRef={fileInputRef}
              handleImageChange={handleImageChange}
              deleteImg={deleteImg}
              saveImage={saveImage}
              setTempImage={setTempImage}
            />
          </TabPanel>
        </TabsBody>
      </Tabs>
      <Footer />
      <MenuBar open={menuOpen} close={closeMenuBar} />
      <AddLeaderProfile
        open={addLeader}
        close={() => setAddLeader(false)}
        isEditing={isChange !== ""}
      />
      <DeleteAccountModal
        open={deleteAccountOpen}
        close={() => setDeleteAccountOpen(false)}
        userProfile={parsedUserProfile}
      />
      {/* Add a new course, a focus window jumping out. */}
    </div>
  );
}
